import { toast } from 'react-toastify';
import { useState } from "react";
import { axiosApi } from "config";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ButtonToolbar, Form, InputGroup } from "rsuite";
import GoogleAuth from "components/googleAuth/GoogleAuth";

export default function Register() {
  const [loading, setLoading] = useState(false);
  const [pwd_visible, setPwdVisible] = useState(false);
  const navigator = useNavigate();

  const handleChangePasswordView = () => {
    setPwdVisible(!pwd_visible);
  };

  const handleSubmit = async (data) => {
    if (data.password.length < 8) {
      toast.warn("The password should be more than 8 characters.");
      return false;
    }
    try {
      setLoading(true);
      const res = await axiosApi.post("/auth/signup", data);
      if(res) {
        toast.success("User has been registered successfully!");
        setLoading(false);
        navigator("/auth/sign-in");
      }
    } catch (err) {
      let msg = err?.response?.data?.statusMsg || "Please check your credentials";
      toast.error(msg);
      setLoading(false);
    }
  }

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-[32px] lg:mb-10 lg:items-center lg:justify-end">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-normal text-navy-700 dark:text-white">
          Welcome to <span className="font-bold">Riplestack</span>
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Ready to manage all your social media accounts from one place?
        </p>
        <Form fluid onSubmit={handleSubmit}>
          <Form.Group controlId="name">
            <Form.ControlLabel>Name*</Form.ControlLabel>
            <Form.Control placeholder="John Doe" required name="name" type="text" />
          </Form.Group>
          <Form.Group controlId="email">
            <Form.ControlLabel>Email*</Form.ControlLabel>
            <Form.Control placeholder="name@email.com" required name="email" type="email" />
          </Form.Group>
          <Form.Group controlId="password">
            <Form.ControlLabel>Password*</Form.ControlLabel>
            <InputGroup inside>
              <Form.Control required name="password" placeholder="Min. 8 characters" type={pwd_visible ? 'text' : 'password'} />
              <InputGroup.Button onClick={handleChangePasswordView}>
                {pwd_visible ? 'Hide' : 'Show'}
              </InputGroup.Button>
            </InputGroup>
          </Form.Group>
          {/* Checkbox */}
          <Form.Group>
            <ButtonToolbar>
              <button
                type="submit"
                disabled={loading}
                className="relative flex items-center justify-center bg-gradient-to-b from-[#7F03E2] to-[#A13BF2] px-[40px] linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
              >
                {loading ? "Loading..." : "Sign Up"}
              </button>
            </ButtonToolbar>
          </Form.Group>
        </Form>
        <p className="mb-9 mt-3 ml-1 text-base text-gray-600">
          Already have an account? <Link to="/auth/sign-in">Sign In</Link>
        </p>
        <div className="mt-3 mb-6 flex items-center gap-3">
          <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
          <p className="text-base text-gray-600 dark:text-white"> or </p>
          <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
        </div>
        {/* Google Authentication Button */}
        <div className="w-full flex justify-center">
          <GoogleAuth />
        </div>
      </div>
    </div>
  );
}
